module.exports = __webpack_public_path__ + "assets/img/9d96a6084b0473f7f767d589b32e073d.png";